// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
// 字体
// Vuetify 使用 Roboto 作为默认字体。
import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

// 斜体版本
import '@fontsource/roboto/100-italic.css'
import '@fontsource/roboto/300-italic.css'
import '@fontsource/roboto/400-italic.css'
import '@fontsource/roboto/500-italic.css'
import '@fontsource/roboto/700-italic.css'
import '@fontsource/roboto/900-italic.css'

// Material Design Icons
// 使用 CDN 加载(在 public/index.html 中),避免本地打包路径问题
import '@mdi/font/css/materialdesignicons.css'



import { zhHans, en, it } from 'vuetify/locale'
import { myCustomLightTheme } from './theme'

const lang = window.$str.getLanguage()


const vuetify = createVuetify({
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    },
  },
  components: {
    ...components,
    VDateInput,
  },
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  defaults: {
    VBtn: {
      // rounded: 'pill',
    },
    VTextField: {
      density: 'compact',
      rounded: 'pill',
      color: 'primary',
    },
    VTextarea: {
      color: 'primary',
    },
    VSelect: {
      color: 'primary',
      menuProps: {
        contentClass: 'global-v-select-menu',
      },
    },
    VAutocomplete: {
      color: 'primary',
      menuProps: {
        contentClass: 'global-v-select-menu',
      },
    },
  },
  locale: {
    locale: lang,
    fallback: 'cn',
    messages: { cn: zhHans, en, it },
  },
})



export default vuetify

